import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_serializableProperties1162nosnaangd as get_serializableProperties } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { getContextual3ijx86afthbix as getContextual } from './serializerManipulation.mjs';
import {
  DataClassPathAccess3qupo9g6dhbeb as DataClassPathAccess,
  DataClassPathSelf18kqeagzkbefr as DataClassPathSelf,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import { SortParte7ewatwctfe4 as SortPart } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortPart.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { get_indexed2rygxbbvfuc29 as get_indexed } from './Annotations.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { get_displayName3v1e4ru2it5uv as get_displayName } from './DataClassRenderer.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { sortWith4fnm6b3vw03s as sortWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Companion_getInstance1genqokpkr3uz as Companion_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  serializer345btyh1f2y1j as serializer,
  serializer1x79l67jvwntn as serializer_0,
  serializer3u3hsxnenk49x as serializer_1,
  serializer1r0h5yakm679b as serializer_2,
  serializer1tw0a8bv7lkga as serializer_3,
  serializer1hu9wv9at41ww as serializer_4,
  serializerodflzzf6s3fp as serializer_5,
  serializer36584sjyg5661 as serializer_6,
  serializer1q7c5q67ysppr as serializer_7,
  serializer3ikrxnm8b29d6 as serializer_8,
  serializer2lw83vwvpnyms as serializer_9,
  serializer1x80idigipeic as serializer_10,
  serializer1j5a5justjsv5 as serializer_11,
  serializer37oyvz7rc4nep as serializer_12,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  StringCompanionObject_instance2dx16b5pp3v3z as StringCompanionObject_instance,
  BooleanCompanionObject_instance2tls5h1cufcrh as BooleanCompanionObject_instance,
  ByteCompanionObject_instance1r92wkzdy7g72 as ByteCompanionObject_instance,
  ShortCompanionObject_instance33mqksfmw0mrs as ShortCompanionObject_instance,
  IntCompanionObject_instance3g0jtywew2pgh as IntCompanionObject_instance,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import {
  CaselessStringSerializer_getInstance27w6j67zgbnak as CaselessStringSerializer_getInstance,
  TrimmedStringSerializer_getInstance74f8ucioonvq as TrimmedStringSerializer_getInstance,
  TrimmedCaselessStringSerializer_getInstance54hltjmd2vdo as TrimmedCaselessStringSerializer_getInstance,
} from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { Companion_instancel8ig9z4updma as Companion_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Primitives.mjs';
import { Companion_getInstanceb1xi7131i8df as Companion_getInstance_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { Companion_getInstance1foc7f9q9rk1s as Companion_getInstance_1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { Companion_getInstance1crempiiqys0g as Companion_getInstance_2 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import { Companion_getInstance11ies3wlxhmd7 as Companion_getInstance_3 } from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance_4 } from '../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import { Companion_getInstance138pnyl3l6agm as Companion_getInstance_5 } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Instant.mjs';
import { Companion_getInstance3h03aipe2gus4 as Companion_getInstance_6 } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { Companion_getInstance29buwn7hkq75x as Companion_getInstance_7 } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDateTime.mjs';
import { Companion_getInstance3qlladteis94 as Companion_getInstance_8 } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalTime.mjs';
import { Companion_getInstance2jahap30xtp3t as Companion_getInstance_9 } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationMsSerializer_getInstancecr673uo7gg5q as DurationMsSerializer_getInstance } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Serializers.mjs';
import { plus1ogy4liedzq5j as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { SortPartSerializerr929bckmbnab as SortPartSerializer } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortPartSerializer.mjs';
import {
  MutableReactive2qdhhyljdknhy as MutableReactive,
  Reactive1jy75v4li6ldv as Reactive,
} from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
import {
  labeledForm2ame2d0a5lql9 as labeledForm,
  labeledView3rpvir7z2o9ii as labeledView,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function registerSortPath(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'com.lightningkite.services.database.SortPart'), SortPathRenderer_getInstance());
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function _init_$traverse($module, this$0, serializer, base) {
  var tmp0_safe_receiver = get_serializableProperties(serializer);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp0_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp0_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.let' call
      var it = element.get_serializer_u29zhh_k$();
      var tmp;
      if (it instanceof ContextualSerializer()) {
        var tmp_0 = $module.serializersModule_1;
        tmp = getContextual(tmp_0, it instanceof ContextualSerializer() ? it : THROW_CCE());
      } else {
        tmp = it;
      }
      var ser = tmp;
      if (SortPathRenderer_getInstance().comparableTypes_1.contains_aljjnj_k$(ser.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$())) {
        var access = new (DataClassPathAccess())(base, element);
        if (!SortPathRenderer_getInstance().stringTypes_1.contains_aljjnj_k$(ser.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$())) {
          var tmp0 = this$0.options_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var elements = listOf([new (SortPart())(access, true, false), new (SortPart())(access, false, false)]);
          addAll(tmp0, elements);
        } else {
          var tmp0_0 = this$0.options_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var elements_0 = listOf([new (SortPart())(access, true, false), new (SortPart())(access, false, false), new (SortPart())(access, true, true), new (SortPart())(access, false, true)]);
          addAll(tmp0_0, elements_0);
        }
      }
    }
  }
}
function SortPathRenderer$SortOptions$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp0_safe_receiver = lastOrNull(b.field_1.get_properties_zhllqc_k$());
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_indexed(tmp0_safe_receiver);
  var tmp = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  var tmp0_safe_receiver_0 = lastOrNull(a.field_1.get_properties_zhllqc_k$());
  var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : get_indexed(tmp0_safe_receiver_0);
  var tmp$ret$2 = tmp1_elvis_lhs_0 == null ? false : tmp1_elvis_lhs_0;
  return compareValues(tmp, tmp$ret$2);
}
function SortPathRenderer$SortOptions$toString$lambda(it) {
  return get_displayName(it);
}
var SortOptionsClass;
function SortOptions() {
  if (SortOptionsClass === VOID) {
    class $ {
      constructor(module_0, serializer) {
        this.options_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        _init_$traverse(module_0, this, serializer.inner_1, new (DataClassPathSelf())(serializer.inner_1));
        // Inline function 'kotlin.collections.sortByDescending' call
        var this_0 = this.options_1;
        if (this_0.get_size_woubt6_k$() > 1) {
          // Inline function 'kotlin.comparisons.compareByDescending' call
          var tmp = SortPathRenderer$SortOptions$lambda;
          var tmp$ret$1 = new (sam$kotlin_Comparator$0())(tmp);
          sortWith(this_0, tmp$ret$1);
        }
      }
      toString_vvkzv0_k$(it) {
        var tmp = it.field_1.get_properties_zhllqc_k$();
        var path = joinToString(tmp, ' / ', VOID, VOID, VOID, VOID, SortPathRenderer$SortOptions$toString$lambda);
        var tmp_0;
        if (SortPathRenderer_getInstance().stringTypes_1.contains_aljjnj_k$(it.field_1.get_serializerAny_e3t5u9_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$())) {
          tmp_0 = it.ignoreCase_1 && it.ascending_1 ? path + ' A-Z' : it.ignoreCase_1 ? path + ' Z-A' : it.ascending_1 ? path + ' A-z (case sensitive)' : path + ' z-A (case sensitive)';
        } else {
          tmp_0 = it.ascending_1 ? path + ' Low - High' : path + ' High - Low';
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'SortOptions');
    SortOptionsClass = $;
  }
  return SortOptionsClass;
}
function SortPathRenderer$SortOptions$toString$ref(p0) {
  return constructCallableReference((p0_0) => p0.toString_vvkzv0_k$(p0_0), 1, 0, 180, 'toString', [p0]);
}
var SortPathRendererClass;
function SortPathRenderer() {
  if (SortPathRendererClass === VOID) {
    class $ {
      constructor() {
        SortPathRenderer_instance = this;
        this.name_1 = 'Sort Part';
        this.stringTypes_1 = setOf([serializer(Companion_getInstance()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), serializer_0(StringCompanionObject_instance).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), CaselessStringSerializer_getInstance().descriptor_1.get_serialName_u2rqhk_k$(), TrimmedStringSerializer_getInstance().descriptor_1.get_serialName_u2rqhk_k$(), TrimmedCaselessStringSerializer_getInstance().descriptor_1.get_serialName_u2rqhk_k$()]);
        this.comparableTypes_1 = plus(setOf([serializer_1(BooleanCompanionObject_instance).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), serializer_2(ByteCompanionObject_instance).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), serializer_3(ShortCompanionObject_instance).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), serializer_4(IntCompanionObject_instance).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), serializer_5(Companion_instance).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), serializer_6(Companion_getInstance_0()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), serializer_7(Companion_getInstance_1()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), serializer_8(Companion_getInstance_2()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), serializer_9(Companion_getInstance_3()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), serializer_10(Companion_getInstance_4()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), serializer_11(Companion_getInstance_5()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), Companion_getInstance_6().serializer_9w0wvi_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), Companion_getInstance_7().serializer_9w0wvi_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), Companion_getInstance_8().serializer_9w0wvi_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), serializer_12(Companion_getInstance_9()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), DurationMsSerializer_getInstance().descriptor_1.get_serialName_u2rqhk_k$()]), this.stringTypes_1);
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_28tizu_k$(context, module_0) {
        var tmp;
        var tmp_0 = context.serializer_1;
        if (tmp_0 instanceof SortPartSerializer()) {
          tmp = 1.0;
        } else {
          tmp = -1.0;
        }
        return tmp;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_28tizu_k$(context, module_0);
      }
      columnWidth_g6s04q_k$(context, module_0) {
        return 20.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_g6s04q_k$(context, module_0);
      }
      form_klw3k6_k$(context, value, module_0) {
        var tmp = context.serializer_1;
        var serializer = tmp instanceof SortPartSerializer() ? tmp : THROW_CCE();
        var sortOptions = new (SortOptions())(module_0, serializer);
        var typedValue = isInterface(value, MutableReactive()) ? value : THROW_CCE();
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          var this_0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (Select())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          var tmp = _Constant___init__impl__v45mub(sortOptions.options_1);
          element.bind_64a41i_k$(typedValue, new (Constant())(tmp), SortPathRenderer$SortOptions$toString$ref(sortOptions));
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_klw3k6_k$(context, value, module_0);
      }
      view_3m91zp_k$(context, value, module_0) {
        var tmp = context.serializer_1;
        var serializer = tmp instanceof SortPartSerializer() ? tmp : THROW_CCE();
        var sortOptions = new (SortOptions())(module_0, serializer);
        var typedValue = isInterface(value, Reactive()) ? value : THROW_CCE();
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => sortOptions.toString_vvkzv0_k$($this$invoke.invoke_r7m7el_k$(typedValue)));
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_3m91zp_k$(context, value, module_0);
      }
      cellForm_ks8aws_k$(context, value, module_0) {
        return this.form_klw3k6_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_ks8aws_k$(context, value, module_0);
      }
      cellView_hcodjr_k$(context, value, module_0) {
        return this.view_3m91zp_k$(context, value, module_0);
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_hcodjr_k$(context, value, module_0);
      }
    }
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'SortPathRenderer', VOID, VOID, [Renderer()]);
    SortPathRendererClass = $;
  }
  return SortPathRendererClass;
}
var SortPathRenderer_instance;
function SortPathRenderer_getInstance() {
  if (SortPathRenderer_instance === VOID)
    new (SortPathRenderer())();
  return SortPathRenderer_instance;
}
//region block: exports
export {
  registerSortPath as registerSortPatho3x58i9bfjpo,
};
//endregion

//# sourceMappingURL=SortPathRenderer.mjs.map
